"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsRecipeTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsExport = require("../DmsExport/DmsExport");
var _RecipeStatus = require("../../constants/RecipeStatus");
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsModal = require("../DmsModal/DmsModal");
var _DmsButton = require("../DmsButton/DmsButton");
var _ToggleOn = _interopRequireDefault(require("@mui/icons-material/ToggleOn"));
var _ToggleOff = _interopRequireDefault(require("@mui/icons-material/ToggleOff"));
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _notifications = require("../../service/notifications/notifications");
var _material = require("@mui/material");
var _ContentCopy = _interopRequireDefault(require("@mui/icons-material/ContentCopy"));
var _Share = _interopRequireDefault(require("@mui/icons-material/Share"));
var _DmsRecipeParameterValueModal = require("./DmsRecipeParameterValueModal");
var _log = require("../../service/logging/log.js");
var _Log = require("../../constants/Log.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsRecipeTable.
 * Renders a DmsTable with recipe datas
 * @component
 * @example
 * return (
 *   <DmsRecipeTable />
 * )
 */

const DmsRecipeTable = () => {
  const table = (0, _react.useRef)(null);
  const [itemToToggle, setItemToToggle] = (0, _react.useState)(null);
  const [modalDefault, setModalDefault] = (0, _react.useState)(false);
  const [modalCopyRecipe, setModalCopyRecipe] = (0, _react.useState)(false);
  const [selectedRowData, setSelectedRowData] = (0, _react.useState)("");
  const [modalRecipeParameters, setModalRecipeParameters] = (0, _react.useState)(false);
  const [newName, setNewName] = (0, _react.useState)("");
  const token = (0, _DmsTokenHook.getToken)();
  const handleToggleClick = item => {
    setItemToToggle(item);
    setModalDefault(true);
  };
  const handleShowCopyRecipeModal = row => {
    setSelectedRowData(row);
    setModalCopyRecipe(true);
  };
  const handleShowRecipeParameters = row => {
    setSelectedRowData(row);
    setModalRecipeParameters(true);
  };
  const onToggleStatus = async () => {
    if (!itemToToggle) return;
    try {
      const res = await (0, _DmsFetch.fetchData)("/recipe/toggle_default/".concat(itemToToggle.pk), 'PUT', token);
      if (res.status === _HttpStatus.HTTP_STATUS.OK_200) {
        var _res$data$data, _res$data$data2;
        table.current.updateTable();
        _notifications.Notifications.toast(_reactIntlUniversal.default.get("Success").d("Success"), _notifications.Notifications.TYPE_SUCCESS);
        let logDescription = (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.is_default) === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("UnsetDefaultLog", {
          name: (_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.name
        }).d("Unset recipe ".concat(res.data.data.name, " as Default")) : _reactIntlUniversal.default.get("SetDefaultLog", {
          name: (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.name
        }).d("Set recipe ".concat(res.data.data.name, " as Default"));
        (0, _log.log)(logDescription, _reactIntlUniversal.default.get("Recipe").d("Recipe"), _Log.LogLevel.INFO, _Log.LogType.USER, null, (0, _DmsTokenHook.getToken)());
      }
    } catch (error) {
      console.error("Toggle default failed:", error);
    } finally {
      setModalDefault(false);
    }
  };
  const copyRecipe = async () => {
    const payload = {
      pk: selectedRowData.pk,
      new_name: newName
    };
    try {
      const res = await (0, _DmsFetch.fetchData)("/recipe/copy_recipe", 'POST', token, payload);
      if (res.status === _HttpStatus.HTTP_STATUS.OK_200) {
        table.current.updateTable();
        _notifications.Notifications.toast(_reactIntlUniversal.default.get("Success").d("Success"), _notifications.Notifications.TYPE_SUCCESS);
        let logDescription = _reactIntlUniversal.default.get("CreateACopyLog", {
          name: selectedRowData.name
        }, {
          newName: newName
        }).d("A copy of ".concat(selectedRowData.name, " is created with name ").concat(newName));
        (0, _log.log)(logDescription, _reactIntlUniversal.default.get("Recipe").d("Recipe"), _Log.LogLevel.INFO, _Log.LogType.USER, null, (0, _DmsTokenHook.getToken)());
      }
    } catch (error) {
      console.error("failed copy recipe:", error);
    } finally {
      setModalCopyRecipe(false);
    }
  };
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Default").d("Default"),
    column_name: "is_default",
    control: 'switch',
    function: (value, item) => /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
      onClick: () => handleToggleClick(item),
      icon: value === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? /*#__PURE__*/_react.default.createElement(_ToggleOn.default, null) : /*#__PURE__*/_react.default.createElement(_ToggleOff.default, null),
      variant: value === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? 'success' : 'danger'
    }),
    can_create: false
  }, {
    label: _reactIntlUniversal.default.get("Copy").d("Copy"),
    column_name: "pk",
    width: "5vw",
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_material.Chip, {
      label: _reactIntlUniversal.default.get("CopyRecipe").d("Copy recipe"),
      onClick: () => handleShowCopyRecipeModal(row),
      icon: /*#__PURE__*/_react.default.createElement(_ContentCopy.default, {
        sx: {
          color: "#FFFFFF !important"
        }
      }),
      sx: {
        minWidth: "8vw",
        color: "#FFFFFF",
        backgroundColor: "#4682B4",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        ":hover": {
          backgroundColor: "#5A9BD4"
        }
      }
    })
  }, {
    label: _reactIntlUniversal.default.get("RecipeParameters").d("Recipe parameters"),
    column_name: "pk",
    width: "5vw",
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_material.Chip, {
      label: _reactIntlUniversal.default.get("Parameters").d("Parameters"),
      onClick: () => handleShowRecipeParameters(row),
      icon: /*#__PURE__*/_react.default.createElement(_Share.default, {
        sx: {
          color: "#FFFFFF !important"
        }
      }),
      sx: {
        minWidth: "8vw",
        color: "#FFFFFF",
        backgroundColor: "#468499",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        ":hover": {
          backgroundColor: "#5B9DB3"
        }
      }
    })
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "5vw",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateRecipe", {
          name
        }).d("Update recipe ".concat(name)),
        url: "/recipe",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteRecipe", {
          name
        }).d("Delete recipe ".concat(name)),
        text: _reactIntlUniversal.default.get("Recipe.DeleteMensage", {
          name
        }).d("Delete recipe with name ".concat(name, ". Are you sure about it?")),
        url: "/recipe",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateRecipe").d("Create recipe"),
    url: "/recipe",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "recipe/table",
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: modalDefault,
    onClose: () => setModalDefault(false)
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.is_default) === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("UnsetDefaultItem", {
      name: itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name
    }).d("Unset ".concat(itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name, " as default")) : _reactIntlUniversal.default.get("SetDefaultItem", {
      name: itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name
    }).d("Set ".concat(itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name, " as default")),
    onClose: () => setModalDefault(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.is_default) === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("ConfirmUnsetDefault", {
    name: itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name
  }).d("Are you sure you want to unset ".concat(itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name, " as default?")) : _reactIntlUniversal.default.get("ConfirmSetDefault", {
    name: itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name
  }).d("Are you sure you want to set ".concat(itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.name, " as default?"))), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    text: (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.is_default) === _RecipeStatus.RecipeStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("UnsetDefault").d("Unset as Default") : _reactIntlUniversal.default.get("SetDefault").d("Set as Default"),
    onClick: onToggleStatus
  }))), /*#__PURE__*/_react.default.createElement(_DmsRecipeParameterValueModal.DmsRecipeParameterValueModal, {
    table: table,
    show: modalRecipeParameters,
    row_data: selectedRowData,
    onHide: () => setModalRecipeParameters(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: modalCopyRecipe,
    onClose: () => setModalCopyRecipe(false)
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: _reactIntlUniversal.default.get("CopyRecipeWithName", {
      name: selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.name
    }).d("Copy recipe with name ".concat(selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.name)),
    onClose: () => setModalCopyRecipe(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, _reactIntlUniversal.default.get("CopyRecipeText").d("This action copy all parameter value too"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    label: _reactIntlUniversal.default.get("NewName").d("New name"),
    placeholder: _reactIntlUniversal.default.get("EnterName").d("Enter name"),
    onChange: e => setNewName(e.target.value),
    value: newName,
    variant: "outlined",
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_ContentCopy.default, null)),
      style: {
        paddingLeft: "8px"
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    text: _reactIntlUniversal.default.get("Copy").d("Copy"),
    onClick: copyRecipe
  }))));
};
exports.DmsRecipeTable = DmsRecipeTable;